// This file contains internationalization utilities for the application.
const translations = {
  'textinput.placeholder': 'Nachricht senden',
  'header.name': '',
  'header.subtitle': '',
  'header.closebutton.label': 'Chat schließen',
  'fileupload.success.single': 'Eine Datei wurde hochgeladen.',
  'fileupload.success.multiple': '{count} Dateien wurden hochgeladen.',
  'fileupload.clickHere.aria': 'Klicken Sie hier, um die Datei(en) auszuwählen',
  'fileupload.clickHere.label': 'hier klicken',
  'fileupload.dragAndDrop.title': 'Dateien per Drag & Drop hinzufügen oder',
  'fileupload.maxFileCountAndSize': 'Bis zu {maxFiles} Datei(en) und max. {maxSize}',
  'fileupload.filetypes.allowedLabel': 'Erlaubte Dateitypen',

  'fileupload.buttonLabel.tryAgain': 'Erneut versuchen',
  'fileupload.buttonLabel.remove': 'Entfernen',

  'fileupload.maxFileNumberErrorMessageSingle': 'Es kann maxmimal eine Datei hochgeladen werden. ',
  'fileupload.maxFileNumberErrorMessageMultiple': 'Es können maximal {count} Dateien hochgeladen werden.',

  'fileupload.fileUploadErrorMessage': 'Hochladen fehlgeschlagen. Versuchen Sie es erneut',
  'fileupload.filesizeErrorMessage': 'Die Datei ist zu groß',
  'fileupload.filetypeErrorMessage': 'Dieser Dateityp ist nicht erlaubt',

  'fileupload.filevalidationerror.toolarge': 'Die Datei ist zu groß',
  'fileupload.filevalidationerror.filetype': 'Der Dateityp ist nicht erlaubt',

  'fileupload.action.startupload': 'Hochladen',
  'fileupload.action.cancel': 'Abbrechen',
  'fileupload.action.backtobot': 'Weiter zum Bot',

  'delayedCancelInput.default': 'Abbrechen',
  // don't know a good german wording for this
  'ratingbutton.label': 'Show rate conversation buttons',
  'ratingbar.label': 'Bewerte das Gespräch',
  'ratingbar.buttonlabel': 'Bewerte mit {count} Sternen',

  'messages.historyLabel': 'Chat-Nachrichtenverlauf',

  'message.ai.generated': 'Generated',
  'message.ai.sources': 'basiert auf',
  'message.ai.disclaimer': 'KI generierte Texte können Fehler enthalten. Überprüfe wichtige Informationen.',
  'message.ai.pages': 'Pages',
  'message.ai.disclaimerDescription': 'Hinweis zu generierten Inhalten',
  'message.incoming': 'Eingehende Chatnachricht',
  'message.outgoing': 'Ausgehende Chatnachricht',
  'message.from': 'Nachricht von {name}',
  'message.media.downloadimage': 'Bild herunterladen',
  'message.media.video.playpausebutton': 'Video abspielen',

  'input.qr.listLabel': 'Antwortvorschläge',
  'input.buttons.send': 'Nachricht abschicken',
  'input.buttons.attachment': 'Dateien anhängen',

  'teaser.close': 'Chat-Einleitung schließen',

  'widgetbutton.button': 'Chat öffnen',
  'iframe.widget.title': 'Chat Rahmen',
  'iframe.teaser.title': 'Chat-Einleitung Rahmen',
  'iframe.button.title': 'Öffen Chat Rahmen', // TODO Better name; can be misinterpreted as an action rather than the container purpose
} as const;

// Define valid translation keys based on the translations object
export type TranslationKeys = keyof typeof translations;

export function useI18n() {
  const mergeLocaleMessages = (messages: Record<TranslationKeys | string, string>) => {
    Object.keys(messages).forEach((key) => {
      (translations as Record<string, string>)[key] = messages[key];
    });
  }

  const mergeLocaleMessage = (key: TranslationKeys, message: string | undefined) => {
    if (!key || !message) return;
    (translations as Record<string, string>)[key] = message;
  }

  const translate = (key: TranslationKeys, named?: Record<string, string | number>) => {
    const translation = translations[key];
    if (!translation && translation !== '') {

      console.error('Translation not found for key:', key);
      return key;
    }

    if (named) {
      let temp = translation as string;
      Object.keys(named).forEach((name) => {
        const regex = new RegExp(`{${name}}`, 'g');
        temp = temp.replace(regex, named[name].toString());
      });
      return temp;
    }
    return translation;
  };

  return {
    t: translate,
    mergeLocaleMessage,
    mergeLocaleMessages,
  };
}
